export const DEMO_QUOTE = {
  id: 'demo-quote-1',
  createdBy: '46204534-85ba-4187-96d9-9cc5d7175b31',
  quoteNumber: 'Q00001',
  title: 'Foo',
  currency: 'USD' as const,
  pdfStatus: 'NOT_YET_REQUESTED' as const,
  presentation: [
    {
      config: {
        text: []
      },
      version: 1,
      blockType: 'paragraph'
    }
  ],
  customerId: '',
  publishedAt: '',
  expiresAt: '2024-06-27',
  isExpired: false,
  status: 'DRAFT' as const,
  dealType: 'NEW_BUSINESS' as const,
  createdAt: '2024-05-28T09:38:32.307766Z',
  updatedAt: '2024-05-28T10:55:57.776435Z',
  readyToSignAt: '',
  expiryDays: 30,
  merchantBranding: {
    logoUrl: '',
    legalCompanyName: 'AcmeLabs',
    primaryColour: '#2A9EDB',
    address: {
      line1: '',
      line2: '',
      town: '',
      postcode: '',
      country: 'GB' as const
    },
    email: ''
  },
  phases: [
    {
      id: '018fbed7-b1aa-7baa-ade6-0f3faaa4982d',
      createdAt: '2024-05-28T10:55:57.866154Z',
      name: 'Phase 1',
      duration: {
        months: 0,
        years: 1
      },
      prices: [],
      discounts: [],
      minimums: []
    }
  ],
  contacts: [],
  counterSigners: [],
  isSignaturesEnabled: true,
  attachmentAssets: []
}
